module.exports = __webpack_public_path__ + "img/dexi_gesture_research.4637c287.png";